import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import AppFooter from "../components/AppFooter";

const RefundPolicy = () => {
  const navigate = useNavigate();

  const sections = [
    {
      title: "1. Subscription Refunds",
      content: `Our focus is complete customer satisfaction. Subscription Plans are refundable upon cancellation up to 3 working days post purchase.`,
    },

    {
      title: "2. Eligible Platforms",
      content: `Purchases can be made via:
• aicahealth.com
• AICA HEALTH mobile applications
• AICA HEALTH web applications`,
    },

    {
      title: "3. Refund Processing Timeline",
      content: `Refund processing time is approximately:
• 15 working days for processing
• 10 working days for credit settlement after approval`,
    },

    {
      title: "4. Payment Deductions",
      content: `Applicable banking charges, gateway fees, taxes, or third-party transaction costs may be deducted before refund settlement.`,
    },

    {
      title: "5. Refund Eligibility",
      content: `Refunds may not apply in cases involving:
• policy violations
• misuse of services
• enterprise agreements
• consumed or utilized services
• non-refundable promotional plans`,
    },

    {
      title: "6. Contact Support",
      content: `For refund-related assistance, users may contact AICA support through official communication channels.`,
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-cyan-50 to-blue-100 relative overflow-hidden">

      {/* Background Glow */}
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-cyan-200/40 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-[350px] h-[350px] bg-blue-300/30 rounded-full blur-3xl"></div>

      {/* Main Container */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 py-10">

        {/* Header */}
        <div className="text-center mb-10">

          <div className="inline-flex items-center px-5 py-2 rounded-full bg-white/80 border border-cyan-200 backdrop-blur-xl text-sm text-cyan-700 shadow-lg">
            AICA HEALTH POLICY
          </div>

          <h1 className="mt-6 text-4xl sm:text-5xl font-bold tracking-tight text-slate-800">
            Refund Policy
          </h1>

          <p className="mt-4 text-slate-600 max-w-2xl mx-auto text-sm sm:text-base leading-relaxed">
            Transparent and customer-friendly refund guidelines for all AICA
            subscriptions, services, and healthcare platform operations.
          </p>
        </div>

        {/* Policy Cards */}
        <div className="space-y-6">

          {sections.map((sec, i) => (
            <div
              key={i}
              className="relative overflow-hidden rounded-3xl border border-white/60 bg-white/70 backdrop-blur-2xl shadow-xl p-6 sm:p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
            >

              {/* Glass Shine */}
              <div className="absolute inset-0 bg-gradient-to-br from-white/40 to-transparent pointer-events-none"></div>

              <div className="relative z-10">
                <h2 className="text-xl sm:text-2xl font-bold mb-4 text-slate-800">
                  {sec.title}
                </h2>

                <p className="text-slate-600 whitespace-pre-line leading-relaxed text-sm sm:text-base">
                  {sec.content}
                </p>
              </div>

            </div>
          ))}

        </div>

        {/* Footer */}
       <div className="mt-10 flex justify-center">
       
                 <button
                   onClick={() => navigate("/")}
                   className="
                   flex items-center gap-2
                   px-6 py-3
                   rounded-2xl
                   bg-gradient-to-r from-cyan-500 to-blue-500
                   text-white
                   font-semibold
                   shadow-lg
                   hover:scale-105
                   hover:shadow-cyan-300/50
                   transition-all duration-300
                 "
                 >
                   <ArrowLeft size={18} />
                   Go Back
                 </button>
                </div>

      </div>
       {/* <AppFooter /> */}
    </div>
  );
};

export default RefundPolicy;